import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../Home/Homepage.css";
import "../Trading/CurrencyPairManagementPage.css";
import "../Trading/AddCurrencyPairPage.css";

const STATIC_COINS = ["BTC", "ETH", "USDT", "BNB", "SOL", "XRP", "ADA", "DOGE", "AVAX", "MATIC"];

const STATIC_PACKAGES = {
  sp1: { id: "sp1", coin: "ETH", packageName: "ETH Staking 30D", apy: 5, lockDays: 30, minAmount: 1, maxAmount: 100, description: "Ethereum staking for 30 days" },
  sp2: { id: "sp2", coin: "BTC", packageName: "BTC Staking 90D", apy: 4.5, lockDays: 90, minAmount: 0.01, maxAmount: 10, description: "Bitcoin staking 90 days lock" },
  sp3: { id: "sp3", coin: "USDT", packageName: "USDT Flexible", apy: 3, lockDays: 0, minAmount: 100, maxAmount: 10000, description: "Flexible USDT staking" },
  sp4: { id: "sp4", coin: "BNB", packageName: "BNB Lock 60D", apy: 6, lockDays: 60, minAmount: 10, maxAmount: 500, description: "" },
  sp5: { id: "sp5", coin: "SOL", packageName: "SOL Staking 30D", apy: 7, lockDays: 30, minAmount: 50, maxAmount: 5000, description: "" },
  sp6: { id: "sp6", coin: "XRP", packageName: "XRP 90D Lock", apy: 4, lockDays: 90, minAmount: 500, maxAmount: 50000, description: "" },
};

const EditStakingPackagePage = () => {
  const navigate = useNavigate();
  const { packageId } = useParams();
  const [form, setForm] = useState({
    coin: "",
    packageName: "",
    apy: "",
    lockDays: 0,
    minAmount: "",
    maxAmount: "",
    description: "",
  });
  const [successModal, setSuccessModal] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const pkg = STATIC_PACKAGES[packageId];
    if (pkg) {
      setForm({
        coin: pkg.coin,
        packageName: pkg.packageName,
        apy: pkg.apy,
        lockDays: pkg.lockDays,
        minAmount: pkg.minAmount,
        maxAmount: pkg.maxAmount,
        description: pkg.description || "",
      });
    } else {
      setNotFound(true);
    }
  }, [packageId]);

  const updateForm = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    if (!form.coin || !form.packageName || !form.apy) return;
    setSuccessModal(true);
  };

  const handleSuccessClose = () => {
    setSuccessModal(false);
    navigate("/dashboard/staking-packages");
  };

  if (notFound) {
    return (
      <main className="dashboard-main dashboard-subpage">
        <section className="dashboard-hero">
          <div className="dashboard-hero__text">
            <p className="dashboard-hero__breadcrumb">
              <Link to="/dashboard/homepage">Dashboard</Link>
              <span style={{ margin: "0 0.35rem" }}>/</span>
              <Link to="/dashboard/staking-packages">Staking</Link>
              <span style={{ margin: "0 0.35rem" }}>/</span>
              <span>Edit Package</span>
            </p>
            <h1 className="dashboard-hero__title">Package Not Found</h1>
          </div>
        </section>
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <p>Package not found. <Link to="/dashboard/staking-packages">Back to Packages</Link></p>
        </div>
      </main>
    );
  }

  return (
    <main className="dashboard-main dashboard-subpage addpair-page">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <Link to="/dashboard/staking-packages">Staking</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Edit Package</span>
          </p>
          <h1 className="dashboard-hero__title">Edit Staking Package</h1>
          <p className="dashboard-hero__subtitle">Update staking package details</p>
        </div>
        <div className="dashboard-hero__icon addpair-hero__icon">
          <i className="fas fa-edit" />
        </div>
      </section>

      <div className="dashboard-body addpair-body">
        <div className="addpair-card">
          <form onSubmit={handleSubmit} className="addpair-form">
            <div className="addpair-config-grid">
              <div className="cp-field">
                <label>Coin <span className="required">*</span></label>
                <div className="cp-input-wrap">
                  <i className="fas fa-gem" />
                  <select
                    value={form.coin}
                    onChange={(e) => updateForm("coin", e.target.value)}
                    required
                  >
                    <option value="">Select Coin</option>
                    {STATIC_COINS.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="cp-field">
                <label>Package Name <span className="required">*</span></label>
                <div className="cp-input-wrap">
                  <i className="fas fa-tag" />
                  <input
                    type="text"
                    placeholder="e.g. ETH Staking 30D"
                    value={form.packageName}
                    onChange={(e) => updateForm("packageName", e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>APY (%) <span className="required">*</span></label>
                <div className="cp-input-wrap">
                  <i className="fas fa-percent" />
                  <input
                    type="number"
                    step="0.01"
                    min={0}
                    placeholder="5.5"
                    value={form.apy}
                    onChange={(e) => updateForm("apy", e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>Lock Period (Days)</label>
                <div className="cp-input-wrap">
                  <i className="fas fa-lock" />
                  <input
                    type="number"
                    min={0}
                    placeholder="0 = Flexible"
                    value={form.lockDays}
                    onChange={(e) => updateForm("lockDays", Number(e.target.value) || 0)}
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>Min Amount</label>
                <div className="cp-input-wrap">
                  <i className="fas fa-coins" />
                  <input
                    type="number"
                    step="any"
                    min={0}
                    placeholder="1"
                    value={form.minAmount}
                    onChange={(e) => updateForm("minAmount", e.target.value)}
                  />
                </div>
              </div>
              <div className="cp-field">
                <label>Max Amount</label>
                <div className="cp-input-wrap">
                  <i className="fas fa-coins" />
                  <input
                    type="number"
                    step="any"
                    min={0}
                    placeholder="100"
                    value={form.maxAmount}
                    onChange={(e) => updateForm("maxAmount", e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="cp-field">
              <label>Description (optional)</label>
              <div className="cp-input-wrap">
                <textarea
                  rows={3}
                  placeholder="Package details..."
                  value={form.description}
                  onChange={(e) => updateForm("description", e.target.value)}
                  style={{ width: "100%", padding: "0.65rem", border: "none", background: "none" }}
                />
              </div>
            </div>
            <div className="addpair-actions">
              <Link to="/dashboard/staking-packages" className="cp-btn cp-btn--outline">Cancel</Link>
              <button type="submit" className="cp-btn cp-btn--primary">
                <i className="fas fa-save" /> Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>

      {successModal && (
        <div className="addpair-success-overlay" onClick={handleSuccessClose}>
          <div className="addpair-success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="addpair-success-icon"><i className="fas fa-check-circle" /></div>
            <h3>Package Updated Successfully</h3>
            <p>Staking package has been updated (static demo).</p>
            <button type="button" className="cp-btn cp-btn--primary" onClick={handleSuccessClose}>Done</button>
          </div>
        </div>
      )}
    </main>
  );
};

export default EditStakingPackagePage;
